<script setup>
// 광고(배너) 영역
// 배너 목록은 public/ad/banners.json 설정 파일에서 읽어온다. (빌드 없이 파일만 수정하면 반영)
import { ref, computed, onMounted, onBeforeUnmount } from "vue";

const BANNER_CONFIG_URL = "/ad/banners.json";

const banners = ref([]);
const currentIdx = ref(0);
const autoRotateSec = ref(0);
let rotateTimer = null;

const hasBanner = computed(() => banners.value.length > 0);
const hasMultiple = computed(() => banners.value.length > 1);
const currentBanner = computed(() => (hasBanner.value ? banners.value[currentIdx.value] : null));

const loadBanners = async () => {
  try {
    const res = await fetch(BANNER_CONFIG_URL, { cache: "no-cache" });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const config = await res.json();
    const list = Array.isArray(config.banners) ? config.banners : [];
    banners.value = list.filter((b) => b && b.image && b.enabled !== false);
    autoRotateSec.value = Number(config.autoRotateSec) || 0;
    currentIdx.value = 0;
    startAutoRotate();
  } catch (e) {
    console.warn("광고 배너 설정 로드 실패:", e);
    banners.value = [];
  }
};

const move = (step) => {
  if (!hasMultiple.value) return;
  const len = banners.value.length;
  currentIdx.value = (currentIdx.value + step + len) % len;
};

const prev = () => {
  move(-1);
  startAutoRotate(); // 수동 조작 시 타이머 리셋
};

const next = () => {
  move(1);
  startAutoRotate();
};

const stopAutoRotate = () => {
  if (rotateTimer) {
    clearInterval(rotateTimer);
    rotateTimer = null;
  }
};

const startAutoRotate = () => {
  stopAutoRotate();
  if (hasMultiple.value && autoRotateSec.value > 0) {
    rotateTimer = setInterval(() => move(1), autoRotateSec.value * 1000);
  }
};

onMounted(loadBanners);
onBeforeUnmount(stopAutoRotate);
</script>

<template>
  <!-- 광고영역 -->
  <div class="ad_banner" @mouseenter="stopAutoRotate" @mouseleave="startAutoRotate">
    <a v-if="hasMultiple" href="javascript:void(0);" class="ad_arrow" title="이전" @click.prevent="prev">&lt;</a>
    <div class="ad_slots">
      <a
        v-if="currentBanner"
        :key="currentBanner.id || currentIdx"
        :href="currentBanner.url || 'javascript:void(0);'"
        :target="currentBanner.url ? '_blank' : null"
        :rel="currentBanner.url ? 'noopener noreferrer' : null"
        class="ad_link"
        :title="currentBanner.alt"
      >
        <img :src="currentBanner.image" :alt="currentBanner.alt || '광고'" class="ad_img" />
      </a>
      <span v-else class="ad_slot">광고 영역</span>
    </div>
    <a v-if="hasMultiple" href="javascript:void(0);" class="ad_arrow" title="다음" @click.prevent="next">&gt;</a>
  </div>
  <!-- //광고영역 -->
</template>

<style scoped>
.ad_banner {
  display: flex;
  align-items: center;
  gap: 1.6rem;
  border: 1px solid #DBE0E6;
  border-radius: 1rem;
  background-color: #fff;
  padding: 1.4rem;
}

.ad_arrow {font-size: 2rem;color: #949AA7;padding: 0 1rem;}
.ad_slots {flex: 1;display: flex;align-items: center;justify-content: center;min-height: 6rem;}
.ad_slot {font-size: 1.6rem;color: #C4CAD3;}
.ad_link {display: inline-flex;align-items: center;justify-content: center;}

.ad_img {
  display: block;
  max-width: 180px;
  max-height: 8rem;
  height: auto;
  object-fit: contain;
  border: 1px solid #e3e3e3;
}
</style>
